<div class="d-flex align-items-center">
  <div [class]="providerInfo && providerInfo.useContainerClass === 'yes' ? 'container' : ''">
    <div *ngIf="providerInfo && providerInfo.html" [innerHTML]="providerInfo.html | htmlWithStyle"></div>
  </div>
</div>
